export class FacilityType {
    Id: string;
    Title: string;

    constructor() {}
}



// WEBPACK FOOTER //
// ./Angular/app/_models/facility-type.model.ts